var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDsIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35,
    r: 35,
    fill: "#FFE0EB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_761_38468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2649 50H32.9211C31.758 50 30.8118 49.0538 30.8118 47.8906V33.3594C30.8118 32.1962 31.758 31.25 32.9211 31.25H35.2649C36.428 31.25 37.3743 32.1962 37.3743 33.3594V47.8906C37.3743 49.0538 36.428 50 35.2649 50Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3586 50H24.0149C22.8517 50 21.9055 49.0538 21.9055 47.8906V38.0469C21.9055 36.8837 22.8517 35.9375 24.0149 35.9375H26.3586C27.5218 35.9375 28.468 36.8837 28.468 38.0469V47.8906C28.468 49.0538 27.5217 50 26.3586 50Z",
    fill: "#FF82AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1714 50H41.8276C40.6645 50 39.7182 49.0538 39.7182 47.8906V28.4375H38.4304C37.8282 28.4375 37.2979 28.0977 37.0463 27.5506C36.7946 27.0036 36.8818 26.3798 37.2737 25.9226C37.2781 25.9174 37.2827 25.9122 37.2872 25.9071L42.3013 20.3118C42.4791 20.1134 42.733 20 42.9995 20C43.266 20 43.5198 20.1134 43.6977 20.3118L48.7118 25.9071C48.7164 25.9122 48.7209 25.9174 48.7254 25.9226C49.1172 26.3797 49.2044 27.0036 48.9528 27.5506C48.7011 28.0977 48.1708 28.4375 47.5686 28.4375H46.2808V47.8906C46.2808 49.0538 45.3345 50 44.1714 50Z",
    fill: "#FF82AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_761_38468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(20.4998 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsIcon03);
export default __webpack_public_path__ + "static/media/ds_icon_03.8492f95060e546b1b1a5af62968b7fc6.svg";
export { ForwardRef as ReactComponent };